<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5QpPO4/images/cover.jpg?1733085643098" alt="This image is the cover for the book Return of the Soldier"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Return of the Soldier
      </h1>
      <p class="bookDescription body article font2">
        <b>Rebecca West’s stunning debut novel: The classic story of a soldier’s amnesia and its effect on the women in his life</b><br/>  A strange woman arrives at the door with unsettling news for Jenny and her sister-in-law Kitty: Jenny’s husband has lost his memory while fighting in the war. As their solider returns home, the women discover that his mind is stuck on the woman he loved fifteen years before—the same woman who first delivered the news of his memory loss and whom Jenny and Kitty regard as socially beneath them. As they care for him and react to this news, they come to understand the power of love—past, present, unrequited, and unconditional. Psychologically astute, West’s unforgettable first work of fiction reveals her innate skill at understanding the constructs of class that hamper people’s attempts to connect with one another.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rebecca West
      </h2>
      
      <p class="authorDescription body article"><p>Dame Rebecca West (1892&ndash;1983) is one of the most critically acclaimed and bestselling English novelists, journalists, and literary critics of the twentieth century. In her eleven novels, beginning with <i>The Return of the Soldier, </i>she delved into the psychological landscape of her characters and explored topics including feminism, socialism, love, betrayal, and identity. She was lauded for her wit and intellectual acuity, evident in her prolific journalistic works such as her coverage of the Nuremberg trials for the <i>New Yorker</i>, published as <i>A Train of Powder,</i> and <i>Black Lamb and Grey Falcon</i>, her epic study of Yugoslavia and its people. She had a child with H.G. Wells, but married banker Henry Maxwell Andrews later in life and continued writing until she died in London at age ninety.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?055c034d